import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SimpleInput from 'components/SimpleInput';
import CheckBox from 'components/CheckBox';
import TextArea from 'components/TextArea';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../reducers';

class ConcernsAndResults extends Resetter(Validator(React.Component)) {
  constructor(props) {
    super(props);
    const { customerConcerns = 'N/A', inspectorName = '', installerName = '',
            inspectionResults = 'N/A', locationOfConcern = '',
            materialsLeftOver = '', additionalWorkNeeded = false,
            internalSummary = '' } = this.props;
    this.state = {
      customerConcerns,
      inspectorName,
      installerName,
      inspectionResults,
      internalSummary,
      locationOfConcern,
      materialsLeftOver,
      additionalWorkNeeded,
      errors: {},
    };
  }

  static VALIDATIONS = {
    customerConcerns: true,
    inspectorName: true,
    installerName: true,
    inspectionResults: true,
    internalSummary: true,
    locationOfConcern: true,
    materialsLeftOver: true,
  }

  handleSubmit = (tab) => {
    if (tab === 3 && !this.validate()) return;
    const { customerConcerns, inspectorName, installerName, inspectionResults,
            locationOfConcern, materialsLeftOver,
            additionalWorkNeeded, internalSummary } = this.state;
    this.props.updateFormData({
      customerConcerns,
      inspectorName,
      installerName,
      inspectionResults,
      internalSummary,
      locationOfConcern,
      materialsLeftOver,
      additionalWorkNeeded,
      tab,
    });
  }

  handleNext = () => this.handleSubmit(3);

  handlePrevious = () => this.handleSubmit(1);

  handleCustomerConcerns = e => this.setState({ customerConcerns: e.target.value });

  handleInspectorName = e => this.setState({ inspectorName: e.target.value });

  handleInstallerName = e => this.setState({ installerName: e.target.value });

  handleInspectionResults = e => this.setState({ inspectionResults: e.target.value });

  handleInternalSummary = e => this.setState({ internalSummary: e.target.value });

  handleLocationOfConcern = e => this.setState({ locationOfConcern: e.target.value });

  handleMaterialsLeftOver = e => this.setState({ materialsLeftOver: e.target.value });

  handleAdditionalWorkNeeded = () => {
    this.setState({ additionalWorkNeeded: !this.state.additionalWorkNeeded });
  }
  render = () => {
    const {
        customerConcerns, inspectorName, installerName, inspectionResults,
        locationOfConcern, materialsLeftOver, additionalWorkNeeded, internalSummary, errors,
    } = this.state;
    return (<div>
      <h6 className={S.signatureTitle}>Concerns & Results</h6>
      <TextArea
        label="Customer Concerns *"
        value={customerConcerns}
        errors={errors.customerConcerns}
        onChange={this.handleCustomerConcerns}
        autoFocus
      />
      <TextArea
        label="Location Of The Concern *"
        value={locationOfConcern}
        errors={errors.locationOfConcern}
        onChange={this.handleLocationOfConcern}
        autoFocus
      />
      <TextArea
        label="List any materials left over from the installation that can be used for the repair *"
        value={materialsLeftOver}
        errors={errors.materialsLeftOver}
        onChange={this.handleMaterialsLeftOver}
        autoFocus
      />
      <SimpleInput
        label="Inspector Name*"
        required
        text={inspectorName}
        errors={errors.inspectorName}
        onChange={this.handleInspectorName}
      />
      <SimpleInput
        label="Installer Name*"
        required
        text={installerName}
        errors={errors.installerName}
        onChange={this.handleInstallerName}
      />
      <TextArea
        label="Inspection Results*"
        value={inspectionResults}
        errors={errors.inspectionResults}
        onChange={this.handleInspectionResults}
        autoFocus
      />
      <TextArea
        label="Internal Summary (not shared with Lowe's) *"
        value={internalSummary}
        errors={errors.internalSummary}
        onChange={this.handleInternalSummary}
      />
      <CheckBox
        label="Will additional Work Be Needed? *"
        checked={additionalWorkNeeded}
        errors={errors.additionalWorkNeeded}
        onChange={this.handleAdditionalWorkNeeded}
      />
      <Button label="Next" flat inverse ripple className={S.submit} onClick={this.handleNext} />
      <Button label="Previous" flat inverse ripple className={S.submit} onClick={this.handlePrevious} />
    </div>);
  }
}

ConcernsAndResults.propTypes = {
  customerConcerns: PropTypes.string,
  inspectorName: PropTypes.string,
  locationOfConcern: PropTypes.string,
  materialsLeftOver: PropTypes.string,
  installerName: PropTypes.string,
  inspectionResults: PropTypes.string,
  internalSummary: PropTypes.string,
  additionalWorkNeeded: PropTypes.bool,
  errors: PropTypes.shape({
    customerConcerns: PropTypes.arrayOf(PropTypes.string),
    inspectorName: PropTypes.arrayOf(PropTypes.string),
    installerName: PropTypes.arrayOf(PropTypes.string),
    inspectionResults: PropTypes.arrayOf(PropTypes.string),
    internalSummary: PropTypes.arrayOf(PropTypes.string),
    locationOfConcern: PropTypes.arrayOf(PropTypes.string),
    materialsLeftOver: PropTypes.arrayOf(PropTypes.string),
    additionalWorkNeeded: PropTypes.arrayOf(PropTypes.string),
    materialsResponsibleParty: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {})(ConcernsAndResults);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/repairInspection/concernsAndResults.jsx